var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotspot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.531,
    height: 73.886,
    viewBox: "0 0 85.531 73.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hotspot",
    d: "M52.126,68.26a13.237,13.237,0,1,0,0,18.72,13.237,13.237,0,0,0,0-18.72ZM47.873,82.728a7.176,7.176,0,1,1,2.136-5.108,7.22,7.22,0,0,1-2.136,5.108ZM85.531,77.62a42.486,42.486,0,0,1-12.526,30.24,3.007,3.007,0,0,1-4.253-4.253,36.752,36.752,0,1,0-51.975,0,3.007,3.007,0,1,1-4.253,4.253A42.766,42.766,0,1,1,85.531,77.62Zm-15.205,0a27.38,27.38,0,0,1-8.072,19.488A3.007,3.007,0,1,1,58,92.855a21.546,21.546,0,1,0-30.47,0,3.007,3.007,0,1,1-4.252,4.253A27.56,27.56,0,1,1,70.325,77.62Z",
    transform: "translate(0 -34.855)",
    fill: "#09eab4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspot);
export default __webpack_public_path__ + "static/media/hotspot.a61b667102a6a962a006739fada5c85a.svg";
export { ForwardRef as ReactComponent };